<template>
    <component :is="layout"></component>
</template>

<script type="ts">
import Vue from 'vue'
//import { getAuth } from "firebase/auth";
import { AppModule } from './store/modules/app';

const DefaultLayout = 'logged-out';

export default Vue.extend({
  computed: {
    layout() {
      const routeLayout = (this.$route.meta.layout || DefaultLayout);
      //console.log(this.$route);
      //console.log(`${routeLayout}-layout`);
      return `${routeLayout}-layout`;
    },
  },

});
</script>
<style>
  html,body{
  font-family: 'Poppins', sans-serif;
}
.entity-tabs > .v-tabs-bar .v-tab {
  font-size: 0.75rem;
  min-width: 0;
  padding: 0 6px;
  letter-spacing: 0.04em;
}
span.font-weight-bold.h4 {
  font-size: 1rem !important;
}

.entity-detail .subtitle-1,
.entity-detail .v-toolbar__title .subtitle-1 {
  font-size: 0.8rem !important;
  font-weight: 600 !important;
  color: #9E9E9E !important;
}
.entity-detail span.body-2,
.entity-detail div.body-2,
.entity-detail a.body-2,
.entity-detail .body-2 {
  font-size: 0.7rem !important;
  line-height: 1.3 !important;
}
.theme--light .entity-detail span.body-2,
.theme--light .entity-detail div.body-2,
.entity-detail span.body-2,
.entity-detail div.body-2 {
  color: rgba(0, 0, 0, 0.87) !important;
}
.entity-detail .theme--dark span.body-2,
.entity-detail .theme--dark div.body-2,
.entity-detail .theme--dark .body-2 {
  color: #FFFFFF !important;
}
.entity-detail span.caption {
  font-size: 0.65rem !important;
}
.entity-detail > .v-toolbar,
.entity-detail .v-toolbar.v-toolbar--dense {
  height: 32px !important;
}
.entity-detail > .v-toolbar .v-toolbar__content,
.entity-detail .v-toolbar.v-toolbar--dense .v-toolbar__content {
  height: 32px !important;
  padding: 0 8px;
}
/* Compact alerts inside entity-detail panels */
.entity-detail .v-alert {
  font-size: 0.7rem !important;
  padding: 8px 12px !important;
}
.entity-detail .v-alert p {
  font-size: 0.7rem !important;
  margin-bottom: 4px !important;
}
/* Compact non-icon buttons inside entity-detail panels to x-small */
.entity-detail .v-btn:not(.v-btn--icon) {
  height: 20px !important;
  min-width: 40px !important;
  padding: 0 8px !important;
  font-size: 0.625rem !important;
}

/* ─── Compact data tables ─── */
.v-data-table th {
  font-size: 0.75rem !important;
  height: 32px !important;
  padding: 0 8px !important;
}
.v-data-table td {
  font-size: 0.8rem !important;
  height: 32px !important;
  padding: 0 8px !important;
}
.v-data-table .v-data-table__expanded__content td {
  height: auto !important;
  padding: 8px !important;
}
.v-data-table .v-data-footer {
  font-size: 0.75rem !important;
}
.v-data-table .v-data-footer .v-select {
  font-size: 0.75rem !important;
}
/* Compact avatars inside table cells */
.v-data-table td .v-avatar {
  height: 24px !important;
  min-width: 24px !important;
  width: 24px !important;
}
.v-data-table td .v-list-item__avatar {
  min-width: 24px !important;
  margin: 2px 8px 2px 0 !important;
}
/* Compact chips inside table cells */
.v-data-table td .v-chip {
  margin: 1px 2px !important;
}

/* ─── Compact simple tables ─── */
.v-simple-table th {
  font-size: 0.75rem !important;
  padding: 4px 8px !important;
}
.v-simple-table td {
  font-size: 0.8rem !important;
  padding: 4px 8px !important;
}
</style>
